//@ts-ignore
import { useAuth as useVue3Auth } from "vue3-auth"
import type { User } from '@/types'
import type { Ref } from 'vue'

interface TypedAuth {
    user: Ref<User | null>
    login: (credentials: any) => Promise<any>
    logout: () => Promise<void>
    setUser: (user: User | null) => void
    loggedIn: Ref<boolean>
}

export function useAuth(): TypedAuth {
    return useVue3Auth() as unknown as TypedAuth
}
